(() => {
/* Wild Gainz press verdicts rotation.
   Progressive enhancement: without this script the first outlet's quote
   shows, all logos render full color, and the read article link goes
   straight to the first outlet's article URL. */

class WildgainzPress extends HTMLElement {
  connectedCallback() {
    this.panels = Array.from(this.querySelectorAll('[data-press-panel]'));
    this.logoButtons = Array.from(this.querySelectorAll('[data-press-logo]'));
    this.trigger = this.querySelector('[data-press-trigger]');
    this.triggerLink = this.querySelector('[data-press-link]');
    this.dialogs = Array.from(this.querySelectorAll('[data-press-dialog]'));
    if (this.panels.length === 0) return;

    this.index = 0;
    this.timer = null;
    this.cycleMs = (parseInt(this.dataset.cycleSeconds, 10) || 3) * 1000;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    this.setAttribute('data-enhanced', '');

    this.logoButtons.forEach((button, i) => {
      button.addEventListener('click', () => {
        this.select(i);
        this.restart();
      });
    });

    if (this.trigger) {
      // Pause rotation while the press dialog is open so the quote and
      // modal outlet cannot drift underneath the reader.
      this.trigger.addEventListener('click', () => this.stop());
    }
    this.dialogs.forEach((dialog) => {
      dialog.addEventListener('close', () => this.restart());
    });

    this.reducedMotion.addEventListener('change', () => this.restart());

    if (window.Shopify && window.Shopify.designMode) {
      this.onBlockSelect = (event) => {
        const i = this.logoButtons.indexOf(event.target);
        if (i === -1) return;
        this.select(i);
        this.stop();
      };
      this.onBlockDeselect = (event) => {
        if (this.contains(event.target)) this.restart();
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
    }

    this.restart();
  }

  disconnectedCallback() {
    this.stop();
    if (this.onBlockSelect) {
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
    }
  }

  get autoplayEnabled() {
    return this.dataset.autoplay === 'true' && this.panels.length > 1 && !this.reducedMotion.matches;
  }

  select(index) {
    this.index = index;
    this.panels.forEach((panel, i) => {
      panel.classList.toggle('is-active', i === index);
    });
    this.logoButtons.forEach((button, i) => {
      button.classList.toggle('is-active', i === index);
      button.setAttribute('aria-pressed', i === index ? 'true' : 'false');
    });

    // On the mobile carousel, slide the active logo into view.
    const active = this.logoButtons[index];
    const strip = active ? active.parentElement : null;
    if (active && strip && strip.scrollWidth > strip.clientWidth) {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      strip.scrollTo({
        left: active.offsetLeft - (strip.clientWidth - active.offsetWidth) / 2,
        behavior: reduced ? 'auto' : 'smooth',
      });
    }

    const dialog = this.dialogs[index];
    if (this.trigger && dialog) this.trigger.dataset.modal = dialog.id;
    if (this.triggerLink) {
      const url = this.panels[index].dataset.articleUrl;
      if (url) {
        this.triggerLink.setAttribute('href', url);
      } else if (dialog) {
        this.triggerLink.setAttribute('href', '#' + dialog.id);
      }
    }
  }

  next() {
    this.select((this.index + 1) % this.panels.length);
  }

  restart() {
    this.stop();
    if (this.autoplayEnabled) {
      this.timer = setInterval(() => this.next(), this.cycleMs);
    }
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
}

if (!customElements.get('wildgainz-press')) {
  customElements.define('wildgainz-press', WildgainzPress);
}
})();
